import { BrandsFactory, TBrand, EnhancedFormModel, FormsFactory, LoadingContainer, getNestedProperty, GenericWrapperContext, getBrandUrl, Typography } from "@cakemail-org/ui-components-v2"
import { useEffect, useState } from "react"
import { useLocation, useParams } from "react-router-dom"
import { logError } from "../../../utils/data"
import { Stack } from "@mui/material"
import { useTranslation } from "react-i18next"
import { ELogErrorMsg } from "../../../utils/data/types"
import { hasFeatureFlag } from "../../../utils/limits_features"
import { useContext } from "react"
import { getCurrentPathParams } from "../../../utils/url"
import "./styles.scss"

export function PublicForm() {
    const genericWrapper = useContext(GenericWrapperContext)

    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)
    const [userBrand, setUserBrand] = useState<TBrand | undefined>(genericWrapper?.userBrand || undefined)

    const { t } = useTranslation()
    const location = useLocation()

    // Look at the function comment to know why useParams was not used
    const { params } = getCurrentPathParams()
    const formId = params.formId

    const queryParams = new URLSearchParams(location.search)

    const accountId = queryParams.get('a')
    const token = queryParams.get('t')


    useEffect(() => {
        if (formId && token) {
            fetchFormHtml(formId, token)
        }
        if (!userBrand && accountId) {
            fetchUserBrand(accountId)
        }
    }, [])

    function fetchFormHtml(formId: string, token: string) {
        FormsFactory.renderPublic({ id: formId, token: token })
            .then((html: string) => {
                const formContainer = document.getElementById("form-container")
                if (formContainer) {
                    formContainer.innerHTML = html
                }
            }).catch((error) => {
                setError(true)
                logError(ELogErrorMsg.ErrorGettingForm, error)
            }).finally(() => {
                setLoading(false)
            })
    }

    function fetchUserBrand(accountId: string) {
        BrandsFactory.get({ id: accountId })
            .then((brand) => {
                setUserBrand(brand)
            })
            .catch((error) => {
                return null
            })
    }

    // TODO inject footer for those who are free accounts ?
    console.log(userBrand)

    const insertLogo = userBrand ? getNestedProperty(userBrand, "insert_reseller_logo") : false

    const footerLogo = getBrandUrl({ elKey: "injected_logo", brand: genericWrapper.partnerBrand })

    console.log(insertLogo, footerLogo, userBrand)

    return <Stack className="publicFormPage" flex={1} justifyContent="space-between">
        <Stack id="form-container" alignItems="center" justifyContent="flex-start" width="100%" flex={1} >
            {error && <Stack className="error">{t("general-error-action")}</Stack>}
        </Stack>
        <LoadingContainer loading={loading} >
            {userBrand && footerLogo && <Stack
                gap={2}
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                className="footerLogo"
            >
                <Typography variant="body1" color="white.main">{t("general-powered-by-txt")}</Typography>
                <img height={18} src={footerLogo} alt={userBrand.name} />
            </Stack>}
        </LoadingContainer>
    </Stack>


}

export default PublicForm